const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useCounter, useProgress } =
  window.BAO.Carousel.plugins

class MahinaMonths extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.els.colour?.elements.forEach((colour) => {
      this.listeners.add(colour, 'click', this.changeColour.bind(this, colour))
    })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3,
              spacing: 16,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useCounter({
          counter: this.els?.counter?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }

  changeColour (colour) {
    this.els.colour?.elements.forEach((el) => {
      el.setAttribute('aria-current', el === colour)
    })

    this.els.image?.elements.forEach((image) => {
      if (image.dataset.colour === colour.dataset.colour) {
        image.setAttribute('aria-current', 'true')
      } else {
        image.setAttribute('aria-current', 'false')
      }
    })
  }
}

if (!customElements.get('mahina-months')) {
  customElements.define('mahina-months', MahinaMonths)
}
